import { render } from "./FamilyList.vue?vue&type=template&id=e15d43ce&scoped=true"
import script from "./FamilyList.vue?vue&type=script&lang=js"
export * from "./FamilyList.vue?vue&type=script&lang=js"

import "./FamilyList.vue?vue&type=style&index=0&id=e15d43ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15d43ce"]])

export default __exports__